<template>
  <div class="module_title">{{ title }}</div>
</template>

<script>
export default {
  name: 'ModuleTitle',
  props: ['title']
}
</script>

<style lang="less">
.module_title {
  width: 100vw;
  height: 0.83rem;
  background: #f7f7f7;
  display: flex;
  align-items: center;
  padding-left: 0.22rem;
  font-size: 0.26rem;
  color: #666666;
}
</style>